module.exports = __webpack_public_path__ + "img/LeftStreakArrow.b75d9204.svg";